import { TFunction } from 'react-i18next';

type Tier = {
  name: string;
  label: string;
  tier: number;
  min: number;
  max: number;
  iconName: string;
  nextTier?: string;
};

export function getTier(tier: string, t: TFunction) {
  const TIERS = [
    {
      name: 'TIER_1',
      label: t('installPartnerProgram.TIER_1', 'Starter'),
      tier: 1,
      min: 0,
      max: 50,
      iconName: 'medal',
      nextTier: 'TIER_2',
    },
    {
      name: 'TIER_2',
      label: t('installPartnerProgram.TIER_2', 'Pro'),
      tier: 2,
      min: 51,
      max: 100,
      iconName: 'award',
      nextTier: 'TIER_3',
    },
    {
      name: 'TIER_3',
      label: t('installPartnerProgram.TIER_3', 'Champion'),
      tier: 3,
      min: 101,
      max: Infinity,
      iconName: 'trophy',
    },
  ] as Tier[];

  const foundTier = TIERS.find((t) => t.name === tier);
  if (!foundTier) {
    return {
      iconName: 'question circle outline',
      name: 'TIER_UNKNOWN',
      label: t('installPartnerProgram.TIER_UNKNOWN', 'Unknown Tier'),
      tier: -1,
      min: 0,
      max: 0,
    };
  }
  return foundTier;
}
